import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-relevant-lab-document-component',
  templateUrl: './relevant-lab-document.component.html',
  styleUrls: ['./relevant-lab-document.component.css']
})
export class RelevantLabDocumentComponent {
  documentID: string = '';
  documentType: string = '';
  relevantLabURL: string = null;
  relevantLabURLLoaded = false;
  relevantLabURLError = false;
  relevantLabsLoaded = false;
  relevantLabDocumentLoading = true;

  constructor(
    private location: Location,
    private activatedRoute: ActivatedRoute) {
    this.documentID = this.activatedRoute.snapshot.paramMap.get("id");
    this.documentType = this.activatedRoute.snapshot.paramMap.get("type");
    console.log("type", this.documentType);
  }

  goBack() {
    this.location.back();
  }
}